import { useGLTF } from '@react-three/drei'
import useApp from './hook/useApp'
import Annotation from './Annotation'
import AnnotationTwo from './AnnotationTwo'

export default function ModelOne(props) {
  const { nodes, materials } = useGLTF("https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-knights-move/Bat_Chatillon25t_3dst_BP_MT/model.glb?ver=1.0");

  const { positions, visibility } = useApp()

  return (
    <group {...props} dispose={null}  position={[1,0,0]} receiveShadow>
      <group scale={0.13} rotation={[0, -3.4, 0]} position={positions.one} receiveShadow>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.StaticMeshActor_6_StaticMeshComponent0.geometry}
        material={materials.MI_Bat_Chatillon25t_3DSt_BP_MT_chassis_01}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.StaticMeshActor_7_StaticMeshComponent0.geometry}
        material={materials.MI_Bat_Chatillon25t_3DSt_BP_MT_guns}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.StaticMeshActor_8_StaticMeshComponent0.geometry}
        material={materials.MI_Bat_Chatillon25t_3DSt_BP_MT_hull_01}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.StaticMeshActor_9_StaticMeshComponent0.geometry}
        material={materials.MI_Bat_Chatillon25t_3DSt_BP_MT_segment_track}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.StaticMeshActor_10_StaticMeshComponent0.geometry}
        material={materials.MI_Bat_Chatillon25t_3DSt_BP_MT_turret_01}
      />

      <Annotation position={[0, 38, 0]} marker="one" visibility={visibility.one}>
        <span>
          {' '}
          <img className="c-arrow" src="https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-byzantium/public/arrow.svg" />{' '}
        </span>
      </Annotation>

      {/* <AnnotationTwo position={[-20, 17, -5]} marker="one-1" visibility={!visibility.one}>
        <span>
          {' '}
          <img className="c-arrow" src="https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-byzantium/public/arrow.svg" />{' '}
        </span>
      </AnnotationTwo>

      <AnnotationTwo position={[-5, 17, 17]} marker="one-2" visibility={!visibility.one}>
        <span>
          {' '}
          <img className="c-arrow" src="https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-byzantium/public/arrow.svg" />{' '}
        </span>
      </AnnotationTwo> */}


      </group>


    </group>




  )
}

useGLTF.preload('https://tanki-media-content.tanki.su/tanki-media/3d/battle-pass-knights-move/Bat_Chatillon25t_3dst_BP_MT/model.glb?ver=1.0')
